export default "__VITE_ASSET__FOTfOYmM__"